import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type UpdateTenantCommand, putTenant } from "Infrastructure/Api/Api";
import { getTenantsQueryKey } from "Tenants/Api/Queries/useTenantsQuery";

export function useUpdateTenantMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			id,
			command,
		}: { id: number; command: UpdateTenantCommand }) => putTenant(id, command),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [getTenantsQueryKey(0, 100)],
			});
		},
	});
}
